import React, { useEffect, useState } from 'react';
import BsModal from '../Common/BsModal';
import { useAccounts } from '../../DataStore/AccountsContext';
import TextInput from '../Common/TextInput';
import Notification from '../Common/Notification';
import ajaxAccountChart from '../../util/remote/ajaxAccountChart';
import { useTag } from '../../DataStore/TagContext';
import ActivityLoader from '../Common/ActivityLoader';
import { useTheme } from '../../DataStore/ThemeContext';

const NewOpeningBalance = () => {
    const { 
        getChartOfAccounts, 
        showOpeningBalanceModal, 
        dispatch,
        liabilityAccountListing,
        incomeAccountListing,
        getLiabilityAccounts,
        getIncomeAccounts,
        newAccountDraft
    } = useAccounts();

    const {getTagListing, tagListing} = useTag();
    const {closeSettings, setNotify: generalNotify} = useTheme();


    const [balanceType, setBalanceType] = useState('Income'); // Default selection
    const [balanceDate, setBalanceDate] = useState('');
    const [accountListing, setAccountListing] = useState(false);
    const [balanceAccount, setBalanceAccount] = useState('');
    const [tag, setTag] = useState(0);
    const [notify, setNotify] = useState(null);
    const [loading, setLoading] = useState(false);


    useEffect(()=>{
        getLiabilityAccounts();
        getIncomeAccounts();
    }, [])

    useEffect(()=>{
        if(notify){
            setTimeout(() => {
                setNotify(null);
                setLoading(false);
            }, 5000);
        }
    }, [notify])

    useEffect(()=>{

        switch (balanceType) {
            case "Income":
                setAccountListing(incomeAccountListing);
                break;
            case "Equity":
                setAccountListing(liabilityAccountListing);
                break;
        
            default:
                break;
        }

    }, [balanceType, incomeAccountListing, liabilityAccountListing])

    const handleCloseModal = () => {
        dispatch({ type: 'showOpeningBalanceModal', payload: false });
    };

    const handleSaveChanges = async() => {

        if(!balanceAccount.value){
            setNotify( <Notification
                type="danger"
                message={`${balanceType} account not selected`}
            />)

            return;
        }

        if(balanceDate.length === 0){
            setNotify( <Notification
                type="danger"
                message="Enter balance date, then try again."
            />)
            return;
        }

        setLoading(true);
        const server_response = await ajaxAccountChart.createAccount({
                account_name: newAccountDraft.accountTitle,
                account_number: newAccountDraft.accountNumber,
                category_id: newAccountDraft.accountCategory.value,
                description: newAccountDraft.accountDescription,
                main_account_id: newAccountDraft.mainAccountId.value,
                opening_balance: newAccountDraft.openingBalance,
                balance_date: balanceDate,
                bank_id: newAccountDraft.bankId.value,
                balance_type: balanceType,
                balance_account: balanceAccount.value || 0,
                tag: tag.value || 0

              }
            
        );
        setLoading(false);
        if (server_response.status === 'OK') {
            getChartOfAccounts(true);
            setTag(0);
            setBalanceDate('');
            setBalanceAccount('');
            generalNotify(<Notification type="success" message={server_response.message} />);
            closeSettings();
            handleCloseModal(); // Close modal after saving
        } else {
            setNotify(<Notification type="danger" message={server_response.message} />);
        }



    };


    const RenderAccountListing = () => {
        const options = [];
        if (Array.isArray(accountListing)) {
            accountListing.map((item, key) =>
                options.push({ label: item.account_number + ' ' + item.account_name, value: item.account_id })
            );
        }

        return (
            <TextInput
                label={`${balanceType} Account`}
                type="select"
                leftIcon="fa fa-university"
                placeholder={balanceAccount.label || `Select ${balanceType} Account....`}
                options={options}
                onChange={(item) => setBalanceAccount(item )}
                leftComponent={<i className="fa fa-user-check" onClick={balanceType === 'Income' ? getIncomeAccounts : getLiabilityAccounts}></i>}
                loading={!accountListing}
                wrap
            />
        );
    };

    // Component to render tag dropdown
    const RenderTag = () => {

        const options=[
            { label: '- No project -', value: '0' }
        ];
        if(Array.isArray(tagListing))
        {
            tagListing.map((item, key)=>
                options.push({label:item.tag_name, value:item.tag_id})
            )
        }
        
        return(<TextInput
                label="Tag Opening Balance"
                type="select"
                placeholder={tag.label || "Opening balance is not tagged..."}
                leftIcon="fa fa-tag"
                options={options}
                onChange={item => setTag(item)}
                leftComponent={<i className="fa fa-tag link" onClick={()=>getTagListing(true)}></i>}
                loading={!tagListing}
                wrap
        />)
    };


    return (
        <BsModal
            show={showOpeningBalanceModal}
            onClose={handleCloseModal}
            title="Account Opening Balance"
            footer={
                <>
                    {loading && <ActivityLoader />}
                    {!loading && <>
                    <button className="btn btn-secondary" onClick={handleCloseModal}>
                        Cancel
                    </button>
                    <button className="btn btn-primary" onClick={handleSaveChanges}>
                        Confirm New Account
                    </button>
                    </>}
                </>
            }
        >
            <p className="mb-4">
                Select whether the opening balance should be treated as <strong>Income</strong> or <strong>Equity</strong>.
            </p>
            {notify}
            <div className="balance-type-selection">
                <div className="form-check form-check-inline">
                    <input
                        type="radio"
                        id="income"
                        name="balanceType"
                        value="Income"
                        className="form-check-input"
                        checked={balanceType === 'Income'}
                        onChange={(e) => setBalanceType(e.target.value)}
                    />
                    <label htmlFor="income" className="form-check-label">
                        <i className="fa fa-dollar-sign me-2"></i> Income
                    </label>
                </div>
                <div className="form-check form-check-inline">
                    <input
                        type="radio"
                        id="equity"
                        name="balanceType"
                        value="Equity"
                        className="form-check-input"
                        checked={balanceType === 'Equity'}
                        onChange={(e) => setBalanceType(e.target.value)}
                    />
                    <label htmlFor="equity" className="form-check-label">
                        <i className="fa fa-balance-scale me-2"></i> Equity
                    </label>
                </div>
            </div>


            {RenderAccountListing()}


            <TextInput
                type="date"
                label="Balance Date"
                placeholder="Date"
                leftIcon="fa fa-calendar-alt"
                value={balanceDate}
                onChange={(e)=>setBalanceDate(e.target.value)} 
                required
                wrap
                />
                
            {RenderTag()}
            

        </BsModal>
    );
};

export default NewOpeningBalance;
